import { apiHolder as api } from 'api';
import DefaultMailMenuConfig from './DefaultMailMenuConfig';
import { FLOLDER, MAIL_MENU_ITEM } from '../../../constant';
import { findAndMergeDefaultMenuConfig, getShowByFolder, taskMailMenuShow } from '../util';
import { getIn18Text } from 'api';
import { getMailFromMails } from '@web-mail/util';
const eventApi = api.api.getEventApi();
const systemApi = api.api.getSystemApi();
const MailListMenuConfig = [
    {
        key: MAIL_MENU_ITEM.RE_EDIT,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY,
        group: '2',
        show: mails => {
            const mail = getMailFromMails(mails);
            if (mail === null || mail === void 0 ? void 0 : mail.isTpMail) {
                return false;
            }
            return !getShowByFolder(mail, [FLOLDER.DRAFT]);
        },
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ALL,
        group: '2',
        show: mails => {
            const mail = getMailFromMails(mails);
            if (mail === null || mail === void 0 ? void 0 : mail.isTpMail) {
                return false;
            }
            return !getShowByFolder(mail, [FLOLDER.DRAFT]);
        },
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ATTACH,
        group: '2',
        show: mails => {
            const mail = getMailFromMails(mails);
            if (mail === null || mail === void 0 ? void 0 : mail.isTpMail) {
                return false;
            }
            const { isThread } = mail;
            const { attachment } = mail.entry;
            const isShowAttachBtn = attachment && attachment.some(attach => !attach.inlined && attach.fileType !== 'ics');
            return !!isShowAttachBtn && !(getShowByFolder(mail, [FLOLDER.DRAFT]) || isThread);
        },
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ATTACH_ALL,
        group: '2',
        show: mails => {
            const mail = getMailFromMails(mails);
            if (mail === null || mail === void 0 ? void 0 : mail.isTpMail) {
                return false;
            }
            const { isThread } = mail;
            const { attachment } = mail.entry;
            const isShowAttachBtn = attachment && attachment.some(attach => !attach.inlined && attach.fileType !== 'ics');
            return !!isShowAttachBtn && !(getShowByFolder(mail, [FLOLDER.DRAFT]) || isThread);
        },
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ALL_AS_NEW,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.FORWARD,
        group: '2',
        show: mails => {
            const mail = getMailFromMails(mails);
            if (mail === null || mail === void 0 ? void 0 : mail.isTpMail) {
                return false;
            }
            return !getShowByFolder(mail, [FLOLDER.DRAFT]);
        },
    },
    {
        key: MAIL_MENU_ITEM.RED_FLAG,
        show: taskMailMenuShow,
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.READ,
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.TAG,
        show: taskMailMenuShow,
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.WMFOLLOW,
        show: taskMailMenuShow,
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.DEFER,
        show: (mails, defaultShow) => {
            const mail = getMailFromMails(mails);
            const { isThread } = mail;
            return !isThread && (defaultShow ? defaultShow(mail) : true);
        },
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.COMMENT,
        group: '3',
    },
    {
        key: MAIL_MENU_ITEM.MOVE,
        group: '4',
        show: taskMailMenuShow,
    },
    {
        key: MAIL_MENU_ITEM.TOP,
        group: '4',
        show: taskMailMenuShow,
    },
    {
        key: MAIL_MENU_ITEM.DELETE,
        group: '4',
        show: taskMailMenuShow,
    },
    {
        key: MAIL_MENU_ITEM.DIRECT_DELETE,
        group: '4',
        show: taskMailMenuShow,
    },
    {
        key: MAIL_MENU_ITEM.REPORT,
        group: '4',
    },
    {
        key: MAIL_MENU_ITEM.REPORT_TRUST,
        group: '4',
        show: taskMailMenuShow,
    },
    {
        key: MAIL_MENU_ITEM.SHARE,
        group: '5',
    },
    {
        key: MAIL_MENU_ITEM.DISCUSSION,
        group: '5',
    },
    {
        key: 'more',
        group: '6',
        onlyUnfold: true,
        name: getIn18Text('GENGDUO'),
        show: true,
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.FORWARD_BY_ATTACH,
                group: '1',
                show: mails => {
                    const mail = getMailFromMails(mails);
                    if (mail === null || mail === void 0 ? void 0 : mail.isTpMail) {
                        return false;
                    }
                    const { isThread } = mail;
                    return !isThread && !getShowByFolder(mail, [FLOLDER.DRAFT]);
                },
            },
            {
                key: MAIL_MENU_ITEM.DELIVERY,
                group: '1',
                show: (mails, defaultShow) => {
                    var _a;
                    const mail = getMailFromMails(mails);
                    if (!(process.env.BUILD_ISEDM || ((_a = systemApi === null || systemApi === void 0 ? void 0 : systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion))) {
                        return !!defaultShow && defaultShow(mail);
                    }
                    return false;
                },
                onClick: (mails, defaultClickFn) => {
                    const mail = getMailFromMails(mails);
                    const { entry: { id, threadMessageFirstId }, _account, isThread, } = mail;
                    let mailId = id;
                    if (isThread) {
                        mailId = threadMessageFirstId;
                    }
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {
                            mailId,
                            account: _account,
                            way: 'mailList',
                        },
                        eventStrData: 'delivery',
                    });
                    defaultClickFn && defaultClickFn(mail);
                },
            },
            {
                key: MAIL_MENU_ITEM.SET_FROM_GROUP,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.CREATE_PERSONAL_GROUP,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.OPEN_IN_WINDOW,
                group: '3',
                show: () => {
                    return true;
                },
            },
            {
                key: MAIL_MENU_ITEM.PRINT_MAIL_PREVIEW,
                group: '3',
            },
            {
                key: MAIL_MENU_ITEM.PRINT_MAIL,
                group: '3',
            },
            {
                key: MAIL_MENU_ITEM.EXPORT,
                group: '3',
            },
        ], DefaultMailMenuConfig),
    },
];
export default findAndMergeDefaultMenuConfig(MailListMenuConfig, DefaultMailMenuConfig);
